import {
  GET_EMPLOYEE_PENDING,
  GET_EMPLOYEE_SUCCESS,
  GET_EMPLOYEE_ERROR,
  POST_EMPLOYEE_PENDING,
  POST_EMPLOYEE_SUCCESS,
  POST_EMPLOYEE_ERROR,
  PUT_EMPLOYEE_PENDING,
  PUT_EMPLOYEE_SUCCESS,
  PUT_EMPLOYEE_ERROR,
  DELETE_EMPLOYEE_PENDING,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_ERROR,
  RESET_EMPLOYEE_PASSWORD_PENDING,
  RESET_EMPLOYEE_PASSWORD_SUCCESS,
  RESET_EMPLOYEE_PASSWORD_ERROR,
  CHANGE_PASSWORD_EMPLOYEE_PENDING,
  CHANGE_PASSWORD_EMPLOYEE_SUCCESS,
  CHANGE_PASSWORD_EMPLOYEE_ERROR,
  EMPLOYEE_DATA,
  SET_EMPLOYEE_MODAL,
} from "../../../actions/master-data/employee";

const initialState = {
  newPass: null,
  pending: false,
  error: null,
  data: null,
  detailData: null,
  isOpenModal: false,
  modalType: "",
};

const employee = (state = initialState, action) => {
  switch (action.type) {
    case GET_EMPLOYEE_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_EMPLOYEE_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case GET_EMPLOYEE_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case POST_EMPLOYEE_PENDING:
      return {
        ...state,
        pending: true,
      };
    case POST_EMPLOYEE_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case POST_EMPLOYEE_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case PUT_EMPLOYEE_PENDING:
      return {
        ...state,
        pending: true,
      };
    case PUT_EMPLOYEE_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case PUT_EMPLOYEE_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case DELETE_EMPLOYEE_PENDING:
      return {
        ...state,
        pending: true,
      };
    case DELETE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case DELETE_EMPLOYEE_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case RESET_EMPLOYEE_PASSWORD_PENDING:
      return {
        ...state,
        pending: true,
      };
    case RESET_EMPLOYEE_PASSWORD_SUCCESS:
      const newState = {
        ...state,
        newPass: action.data.data.data.new_password,
        pending: false,
      };
      return newState;
    case RESET_EMPLOYEE_PASSWORD_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case CHANGE_PASSWORD_EMPLOYEE_PENDING:
      return {
        ...state,
        pending: true,
      };
    case CHANGE_PASSWORD_EMPLOYEE_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case CHANGE_PASSWORD_EMPLOYEE_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case EMPLOYEE_DATA:
      return {
        ...state,
        detailData: action.data,
      };
    case SET_EMPLOYEE_MODAL:
      return {
        ...state,
        isOpenModal: action.data.isOpen,
        modalType: action.data.modalType,
      };
    default:
      return state;
  }
};

export default employee;
